import React, { ReactNode } from 'react'

import s from './styles.module.scss'

const FooterDesktop = ({
  onClick,
  label,
  id,
  ...rest
}: {
  onClick: () => void
  label: ReactNode
  id?: string
}) => {
  return (
    <footer className={s.footer} onClick={onClick} id={id} {...rest}>
      <span className={s.underline}>{label}</span>
    </footer>
  )
}

export default FooterDesktop
